import moment from 'moment'

export default {}

export const resetHours = (date: Date): Date => {
  const nextDate = new Date(date)
  nextDate.setHours(0, 0, 0, 0)
  return nextDate
}

// const tomorrow = new Date();
// tomorrow.setDate(tomorrow.getDate() + 1);

// const lastWeek = new Date();
// lastWeek.setDate(lastWeek.getDate() - 7);

export const startOfMonth = (): Date => {
  const today = new Date()
  return resetHours(new Date(today.getFullYear(), today.getMonth() - 1, 1))
}

export const startOfYear = (): Date => {
  const today = new Date()
  return resetHours(new Date(today.getFullYear(), 0, 1))
}

export const endOfMonth = (): Date => {
  const today = new Date()
  return resetHours(new Date(today.getFullYear(), today.getMonth() + 1, 0))
}

// 25-12-2019
export const formatForBreakdownLink = (date: Date): string =>
  moment(date).format('DD-MM-YYYY')

// date to 20191225(YYYYMMDD)
export const formatForAPI = (date: Date): string =>
  moment(date).format('YYYYMMDD')

// DD-MM-YYYY to date
export const ddmmyyyyToDate = (date: string): Date =>
  moment(date, 'DD-MM-YYYY').toDate()

// YYYYMMDD to date
export const apiDateStringToDate = (apiString: string): Date =>
  moment(apiString, 'YYYYMMDD').toDate()

// YYYYMMDD to DD-MM-YYYY
export const yyyymmddToDD_MM_YYYY = (apiString: string): string =>
  moment(apiString, 'YYYYMMDD').format('DD-MM-YYYY')

// date to YYYYMM
export const dateToYYYYMM = (date: Date): string =>
  moment(date).format('YYYYMM')

// date to timestamp
export const dateToTimeStamp = (date: Date): number => moment(date).unix()

export const timeOfDayGreeting = (date: Date): string => {
  const hour = date.getHours()
  switch (true) {
    case hour >= 12 && hour < 18:
      return 'Good afternoon'
    case hour >= 18 || hour <= 3:
      return 'Good evening'
    default:
      return 'Good morning'
  }
}
